import React from 'react';

// Components
import ErrorBoundryComponent from '../pages/auth/ErrorBoundry';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch(error, errorInfo) {
    console.log(error, errorInfo);
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  render() {
    console.log(this.state.errorInfo);
    if (this.state.errorInfo) {
      return (
        <div>
          <ErrorBoundryComponent />
        </div>
      );
    } else return this.props.children;
  }
}
export default ErrorBoundary;
